export const APP_INITIALIZE_REQUESTED = "APP_INITIALIZE_REQUESTED"